import React from 'react';

export const Fallback = () => {
  return (
    <div className='inner-content loading'>
      <div className='loading-center-box'>
        <div className='loader-st01'></div>
        <span className='loading-sub-tit'>
          정보를 불러오고 있어요. <br />
          잠시만 기다려주세요.
        </span>
      </div>
    </div>
  );
};
